import { render, staticRenderFns } from "./ReportingEventList.vue?vue&type=template&id=0b5867b1&"
import script from "./ReportingEventList.vue?vue&type=script&lang=js&"
export * from "./ReportingEventList.vue?vue&type=script&lang=js&"
import style0 from "./ReportingEventList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports